/**
 * audio.ts
 * Audio mixing constants. Read-only exports, no mutable state.
 *
 * @module constants/audio
 */

/** Default music bus volume (0–1). Music sits under SFX so cues stay audible. */
export const DEFAULT_MUSIC_VOLUME = 0.45;

/** Default sound-effect bus volume (0–1). */
export const DEFAULT_SFX_VOLUME = 0.8;

/**
 * Maximum simultaneous voices for a single sound effect. Retriggering a sound
 * that is still playing allocates another element up to this cap, then steals
 * the oldest voice. Keeps rapid-fire cues (shard-fire, enemy-hurt) from
 * cutting themselves off while bounding element count per sound.
 */
export const MAX_SFX_VOICES = 4;
